// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'database-search';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M7.325 7.247C3.468 6.937.562 5.573.562 3.938.563 2.074 4.34.563 9 .563s8.438 1.511 8.438 3.375c0 .886-.854 1.692-2.25 2.295m2.25 2.205v-4.5' />
    <path d='M.563 3.938v4.5c0 1.388 2.093 2.58 5.086 3.099' />
    <path d='M.563 8.438v4.5c0 1.635 2.905 3 6.762 3.309m.55-4.434a3.937 3.937 0 1 0 7.875 0 3.937 3.937 0 0 0-7.875 0zm9.563 5.625-2.841-2.84' />
  </g>
);

export const viewBox = '0 0 18 18';
